/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Testimonial_1_QuoteInputs */

const en_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark transformed my swing in one summer. I dropped 8 strokes off my handicap.`)
};

const es_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark transformó mi swing en un solo verano. Bajé 8 golpes de hándicap.`)
};

const de_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark hat meinen Schwung in einem Sommer verwandelt. Mein Handicap ist um 8 Schläge gesunken.`)
};

const zh_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark 用一个夏天改变了我的挥杆。我的差点降了8杆。`)
};

const ar_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غيّر Mark سواينغي في صيف واحد. خفّضت 8 ضربات من هانديكابي.`)
};

const fr_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark a transformé mon swing en un été. J'ai baissé mon handicap de 8 coups.`)
};

const vi_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark đã thay đổi cú swing của tôi chỉ trong một mùa hè. Handicap của tôi giảm 8 gậy.`)
};

const sw_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark alibadilisha swing yangu katika kiangazi kimoja tu. Nilipunguza handicap yangu kwa mipigo 8.`)
};

const th_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark เปลี่ยนวงสวิงของผมได้ในฤดูร้อนเดียว แฮนดิแคปของผมลดลง 8 สโตรก`)
};

const bs_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark mi je za jedno ljeto potpuno promijenio swing. Hendikep mi je pao za 8 udaraca.`)
};

const ja_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markはひと夏で私のスイングを変えてくれました。ハンディキャップが8打縮まりました。`)
};

const ko_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark는 한 여름 만에 제 스윙을 바꿔 놓았습니다. 핸디캡이 8타 줄었어요.`)
};

const pt_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Mark transformou meu swing em um verão. Baixei 8 tacadas no handicap.`)
};

const it_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark ha trasformato il mio swing in una sola estate. Ho abbassato il mio handicap di 8 colpi.`)
};

const sv_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark förvandlade min sving på en sommar. Jag sänkte mitt handicap med 8 slag.`)
};

const nl_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark veranderde mijn swing in één zomer. Mijn handicap ging met acht slagen omlaag.`)
};

const da_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark forvandlede mit sving på én sommer. Jeg barberede 8 slag af mit handicap.`)
};

const nb_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark forvandlet svingen min på én sommer. Jeg kuttet 8 slag av handicapet mitt.`)
};

const fi_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark muutti swingini yhdessä kesässä. Tasoitukseni laski 8 lyöntiä.`)
};

const pl_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark w jedno lato odmienił mój swing. Obniżyłem handicap o 8 uderzeń.`)
};

const ru_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark преобразил мой свинг за одно лето. Я сбросил 8 ударов с гандикапа.`)
};

const tr_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark tek bir yazda swingimi baştan değiştirdi. Handikapımı 8 vuruş düşürdüm.`)
};

const hi_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark ने एक ही गर्मी में मेरा स्विंग बदल दिया। मेरा हैंडीकैप 8 स्ट्रोक कम हो गया।`)
};

const id_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark mengubah ayunan saya hanya dalam satu musim panas. Handicap saya turun 8 pukulan.`)
};

const ms_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark mengubah hayunan saya dalam satu musim panas. Handicap saya turun 8 pukulan.`)
};

const cs_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark mi za jedno léto proměnil švih. Snížil jsem si handicap o 8 ran.`)
};

const el_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ο Mark άλλαξε εντελώς το σβινγκ μου μέσα σε ένα καλοκαίρι. Κατέβασα το χάντικαπ μου κατά 8 χτυπήματα.`)
};

const he_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark שינה את הסווינג שלי בקיץ אחד. הורדתי 8 חבטות מההנדיקאפ שלי.`)
};

const af_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark het my swing in een somer verander. Ek het 8 slae van my handicap afgehaal.`)
};

const hu_home_testimonial_1_quote = /** @type {(inputs: Home_Testimonial_1_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark egy nyáron belül megváltoztatta a swingemet. 8 ütést javítottam a hendikepemen.`)
};

/**
* | output |
* | --- |
* | "Mark transformed my swing in one summer. I dropped 8 strokes off my handicap." |
*
* @param {Home_Testimonial_1_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_testimonial_1_quote = /** @type {((inputs?: Home_Testimonial_1_QuoteInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Testimonial_1_QuoteInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_testimonial_1_quote(inputs)
	if (locale === "de") return de_home_testimonial_1_quote(inputs)
	if (locale === "zh") return zh_home_testimonial_1_quote(inputs)
	if (locale === "ar") return ar_home_testimonial_1_quote(inputs)
	if (locale === "fr") return fr_home_testimonial_1_quote(inputs)
	if (locale === "vi") return vi_home_testimonial_1_quote(inputs)
	if (locale === "sw") return sw_home_testimonial_1_quote(inputs)
	if (locale === "th") return th_home_testimonial_1_quote(inputs)
	if (locale === "bs") return bs_home_testimonial_1_quote(inputs)
	if (locale === "ja") return ja_home_testimonial_1_quote(inputs)
	if (locale === "ko") return ko_home_testimonial_1_quote(inputs)
	if (locale === "pt") return pt_home_testimonial_1_quote(inputs)
	if (locale === "it") return it_home_testimonial_1_quote(inputs)
	if (locale === "sv") return sv_home_testimonial_1_quote(inputs)
	if (locale === "nl") return nl_home_testimonial_1_quote(inputs)
	if (locale === "da") return da_home_testimonial_1_quote(inputs)
	if (locale === "nb") return nb_home_testimonial_1_quote(inputs)
	if (locale === "fi") return fi_home_testimonial_1_quote(inputs)
	if (locale === "pl") return pl_home_testimonial_1_quote(inputs)
	if (locale === "ru") return ru_home_testimonial_1_quote(inputs)
	if (locale === "tr") return tr_home_testimonial_1_quote(inputs)
	if (locale === "hi") return hi_home_testimonial_1_quote(inputs)
	if (locale === "id") return id_home_testimonial_1_quote(inputs)
	if (locale === "ms") return ms_home_testimonial_1_quote(inputs)
	if (locale === "cs") return cs_home_testimonial_1_quote(inputs)
	if (locale === "el") return el_home_testimonial_1_quote(inputs)
	if (locale === "he") return he_home_testimonial_1_quote(inputs)
	if (locale === "af") return af_home_testimonial_1_quote(inputs)
	if (locale === "hu") return hu_home_testimonial_1_quote(inputs)
	return en_home_testimonial_1_quote(inputs)
});